import styled from 'styled-components';
import colors from '../../../../theme/colors';

export const Divider = styled.div`
    height: 1px;
    background-color: ${colors.grey4};
`;
